/* B&A Label Supply navigation behavior. Keeps dropdowns from staying open after use.
   Runs only on the B&A header and does not change any Shopify product controls. */
(() => {
  function initBAHeader(header) {
    if (!header || header.dataset.baMenuBehaviorReady === 'true') return;
    header.dataset.baMenuBehaviorReady = 'true';
    const nav = header.querySelector('.bam-nav');
    if (!nav) return;
    const menus = [...nav.querySelectorAll('details.bam-drop')];
    const closeMenus = (except = null) => {
      for (const menu of menus) {
        if (menu !== except && menu.open) menu.open = false;
      }
    };

    for (const menu of menus) {
      // Only one department dropdown should remain expanded at a time.
      menu.addEventListener('toggle', () => {
        if (menu.open) closeMenus(menu);
      });

      // Mouse users expect menus to retract as soon as they leave them.
      // Skip touchscreen/pen pointer events so taps remain usable.
      menu.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') menu.open = false;
      });

      // Keep keyboard navigation usable: close only after focus leaves.
      menu.addEventListener('focusout', (event) => {
        const next = event.relatedTarget;
        if (next && !menu.contains(next)) menu.open = false;
      });

      // A clicked destination must not leave the previous menu expanded.
      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => { menu.open = false; });
      });
    }

    // Clicking off the menus closes all expanded departments.
    document.addEventListener('pointerdown', (event) => {
      if (!event.target.closest('.bam-nav details.bam-drop')) closeMenus();
    });

    // Escape dismisses menus and returns keyboard focus to the trigger.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMenu = menus.find((menu) => menu.open);
      if (openMenu) {
        closeMenus();
        openMenu.querySelector('summary')?.focus();
        event.preventDefault();
      }
    });

    // No dropdown should hang in the viewport when the visitor scrolls away.
    window.addEventListener('scroll', () => closeMenus(), { passive: true });
  }
  const setup = () => document.querySelectorAll('.bam-site-header').forEach(initBAHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
